{
  "_access_groups_section": "------------------------------------------",
  "GROUPS_HEADER_SUFFIX": " Groups?",
  "ACCESS_GROUPS_HEADER_SUFFIX": " Access Groups?",
  "ACCESS_GROUP_HEADER_SUFFIX": " Access Group?",
  "ACCESS_GROUP_SITE_CONTENT_SUFFIX": " Access Group at this Site?",
  "ACCESS_GROUP_KEEP_ENABLED": "Keep Enabled",
  "ACCESS_GROUP_KEEP_DISABLED": "Keep Disabled",

  "ACCESS_GROUP_ENABLE_ALL_HEADER": "Enable All Access Groups?",
  "ACCESS_GROUP_ENABLE_ALL_CONTENT_1": "Are you sure you want to enable all Access Groups?",
  "ACCESS_GROUP_ENABLE_ALL_CONTENT_2": "If enabled, Access Groups will be available for use by all of the sites and drivers assigned to them.",
  "ACCESS_GROUP_ENABLE_ALL_SOLID_BUTTON": "Enable All Access Groups",

  "ACCESS_GROUP_DISABLE_ALL_HEADER": "Disable All Access Groups?",
  "ACCESS_GROUP_DISABLE_ALL_CONTENT_1": "Are you sure you want to disable all Access Groups?",
  "ACCESS_GROUP_DISABLE_ALL_CONTENT_2": "If disabled, none of the chargers in your organization will be available for use.",
  "ACCESS_GROUP_DISABLE_ALL_OUTLINE_BUTTON": "Disabled All Access Groups",

  "ACCESS_GROUP_ENABLE_PUBLIC": {
    "header": "Enable Public Access Group?",
    "content": {
      "dialogContent": [
        {
          "bold": false,
          "contentMsg": "Are you sure you want to enable the Public Access Group?"
        },
        {
          "bold": true,
          "contentMsg": "If enabled, the Public will be able to use chargers at any of your sites."
        },
        {
          "bold": true,
          "contentMsg": "You can add usage schedules to this group at the site level to control public access."
        }
      ],
      "solidText": "Enable Access Group",
      "outlineText": "Keep Disabled"
    }
  },

  "DISCARD_CHANGES": {
    "header": "Discard Unsaved Changes?",
    "data": {
      "dialogContent": [
        {
          "bold": false,
          "contentMsg": "You have unsaved changes on this page. If you discard you will lose your changes."
        }
      ],
      "solidText": "Continue Editing",
      "outlineText": "Discard Changes"
    },
    "closeable": false
  },

  "ACCESS_GROUP_ENABLE_PUBLIC_HEADER": "Enable Public Access Group?",
  "ACCESS_GROUP_ENABLE_PUBLIC_CONTENT_1": "Are you sure you want to enable the Public Access Groups?",
  "ACCESS_GROUP_ENABLE_PUBLIC_CONTENT_2": "If enabled, the Public will be able to use chargers at any of your sites.",
  "ACCESS_GROUP_ENABLE_PUBLIC_CONTENT_3": "You can add usage schedules to this group at the site level to control public access.",

  "ACCESS_GROUP_DISABLE_PUBLIC_HEADER": "Disable Public Access Group?",
  "ACCESS_GROUP_DISABLE_PUBLIC_CONTENT_1": "Are you sure you want to disable the Public Access Group?",
  "ACCESS_GROUP_DISABLE_PUBLIC_CONTENT_2": "If disabled, the Public will no longer be able to use chargers at any of your sites.",
  "ACCESS_GROUP_DISABLE_PUBLIC_CONTENT_3": "Not ready to disable?  You can add usage schedules to this group at the site level to control public access.",
  "ACCESS_GROUP_DISABLE_PUBLIC_OUTLINE_BUTTON": "Disable Public Group",

  "ACCESS_GROUP_ENABLE": {
    "header": "Enable $1 Access Group?",
    "data": {
      "dialogContent": [
        {
          "bold": false,
          "contentMsg": "Are you sure you want to enable the $1 Access Group?"
        },
        {
          "bold": true,
          "contentMsg": "If enabled, the $1 Access Group will be available for use by all of the sites and drivers assigned to them."
        }
      ],
      "solidText": "Enable Access Group",
      "outlineText": "Keep Disabled"
    }
  },

  "ACCESS_GROUP_ENABLE_HEADER": "Enable ",
  "ACCESS_GROUP_ENABLE_CONTENT_1": "Are you sure you want to enable the ",
  "ACCESS_GROUP_ENABLE_CONTENT_2_1": "If enabled, ",
  "ACCESS_GROUP_ENABLE_CONTENT_2_2": " Access Groups will be available for use by all of the sites and drivers assigned to them.",
  "ACCESS_GROUP_ENABLE_SOLID_BUTTON": "Enable Access Group",

  "ACCESS_GROUP_DISABLE_HEADER": "Disable ",
  "ACCESS_GROUP_DISABLE_CONTENT_1": "Are you sure you want to disable ",
  "ACCESS_GROUP_DISABLE_CONTENT_2_1": "If disabled, the ",
  "ACCESS_GROUP_DISABLE_CONTENT_2_2": " Access Groups will be not be available for use by any of the sites and drivers assigned to it.",
  "ACCESS_GROUP_DISABLE_OUTLINE_BUTTON": "Disable Access Group",

  "ACCESS_GROUP_SITE_ENABLE_ALL_HEADER": "Enable All Site Access Groups?",
  "ACCESS_GROUP_SITE_ENABLE_ALL_CONTENT_1": "Are you sure you want to enable all Access Groups at this Site?",
  "ACCESS_GROUP_SITE_ENABLE_ALL_CONTENT_2": "If enabled, Access Groups will be available for use at this Site by all of the Chargers and Drivers assigned to them.",
  "ACCESS_GROUP_SITE_ENABLE_ALL_SOLID_BUTTON": "Enable All Access Groups",

  "ACCESS_GROUP_SITE_DISABLE_ALL_HEADER": "Disable All Site Access Groups?",
  "ACCESS_GROUP_SITE_DISABLE_ALL_CONTENT_1": "Are you sure you want to disable all Access Groups at this Site?",
  "ACCESS_GROUP_SITE_DISABLE_ALL_CONTENT_2": "If disabled, none of the chargers at this Site will be available for use.",
  "ACCESS_GROUP_SITE_DISABLE_ALL_OUTLINE_BUTTON": "Disable All Access Groups",

  "ACCESS_GROUP_SITE_ENABLE_HEADER": "Enable Site's ",
  "ACCESS_GROUP_SITE_ENABLE_CONTENT_1": "Are you sure you want to enable the ",
  "ACCESS_GROUP_SITE_ENABLE_CONTENT_2": "This will enable Drivers within this Access Group to use any of the designated chargers at this Site immediately.",
  "ACCESS_GROUP_SITE_ENABLE_SOLID_BUTTON": "Enable",

  "ACCESS_GROUP_SITE_DISABLE_HEADER": "Disable Site's ",
  "ACCESS_GROUP_SITE_DISABLE_CONTENT_1": "Are you sure you want to disable ",
  "ACCESS_GROUP_SITE_DISABLE_CONTENT_2": "Drivers within this Access Group will no longer be able to to use any of the chargers associated with this Access Group at this Site.",
  "ACCESS_GROUP_SITE_DISABLE_OUTLINE_BUTTON": "Disable for Site",

  "ACCESS_GROUP_SITE_CANNOT_ENABLE": {
    "header": "Site Access Group Cannot be Enabled",
    "data": {
      "dialogContent": [
        {
          "bold": false,
          "contentMsg": "An Access Group must contain at least 1 Charger, 1 Driver and an active Schedule to be enabled. "
        }
      ],
      "solidText": "Close"
    }
  },

  "ACCESS_GROUP_DELETE_HEADER": "Delete ",

  "DELETE_ACCESS_GROUP": {
    "header": "Delete $1 Access Group?",
    "data": {
      "dialogContent": [
        {
          "bold": false,
          "contentMsg": "Are you sure you want to delete $1 Access Group?"
        },
        {
          "bold": true,
          "contentMsg": "This will permanently delete the $1 Access Group. This group will no longer be available for use by any sites or drivers. This action cannot be undone."
        }
      ],
      "solidText": "Keep Access Group",
      "outlineText": "Delete Access Group"
    }
  },

  "ACCESS_GROUP_DELETE_CONTENT_1": "Are you sure you want to delete ",
  "ACCESS_GROUP_DELETE_CONTENT_2_1": "This will permanently delete the ",
  "ACCESS_GROUP_DELETE_CONTENT_2_2": " Access Group. This group will no longer be available for use by any sites or drivers. This action cannot be undone.",
  "ACCESS_GROUP_DELETE_SOLID_BUTTON": "Keep Access Group",
  "ACCESS_GROUP_DELETE_OUTLINE_BUTTON": "Delete Access Group",

  "ACCESS_GROUP_DELETE_NUM_CONTENT_1_1": "Are you sure you want to delete ",
  "ACCESS_GROUP_DELETE_NUM_CONTENT_2_1": "This will permanently delete ",
  "ACCESS_GROUP_DELETE_NUM_CONTENT_2_2": " Access Groups.  This group will no longer be available for use by any sites or drivers.  This action cannot be undone.",
  "ACCESS_GROUP_DELETE_NUM_SOLID_BUTTON": "Keep Access Groups",
  "ACCESS_GROUP_DELETE_NUM_OUTLINE_BUTTON_1": "Delete ",
  "ACCESS_GROUP_DELETE_NUM_GROUPS_SUFFIX": " Access Groups",

  "_drivers_section": "------------------------------------------",

  "ENABLE_DRIVER": {
    "header": "Enable $1?",
    "data": {
      "dialogContent": [
        {
          "bold": false,
          "contentMsg": "Are you sure you want to enable $1?"
        },
        {
          "bold": true,
          "contentMsg": "This driver will be enabled and will be able to utilize any chargers they are assigned to."
        }
      ],
      "solidText": "Cancel",
      "outlineText": "Enable Driver"
    }
  },

  "DISABLE_DRIVER": {
    "header": "Disable $1?",
    "data": {
      "dialogContent": [
        {
          "bold": false,
          "contentMsg": "Are you sure you want to disable $1?"
        },
        {
          "bold": true,
          "contentMsg": "This driver will be disabled and will no longer be able to utilize any chargers they aren’t Public."
        }
      ],
      "solidText": "Cancel",
      "outlineText": "Disable Driver"
    }
  },

  "DELETE": "Delete",
  "ARE_YOU_SURE": "Are you sure you want to delete ",
  "FROM_ORG": " from your organization?",
  "DRIVERS_DELETE_CONTENT_1": "Are you sure you want to delete ",
  "DRIVERS_DELETE_CONTENT_2": "This driver will be permanently deleted from your organization and will no longer be able to utilize any chargers that aren't Public.",


  "DRIVERS_DELETE_NUM_HEADER": "",
  "DRIVERS_DELETE_NUM_CONTENT_1": "",
  "DRIVERS_DELETE_NUM_CONTENT_2": "These drivers will be permanently deleted from your organization and will no longer be able to utilize any chargers that aren't Public.",

  "_connectors_section": "------------------------------------------",
  "CONNECTORS_ENABLE_ALL_HEADER": "Enable or Disable All Chargers?",
  "CONNECTORS_ENABLE_ALL_CONTENT_1": "Please select if you would like to enable or disable all Chargers.",
  "CONNECTORS_ENABLE_ALL_CONTENT_2": "If you do not wish to affect all Chargers, you can close this dialog and no action will be taken.",
  "CONNECTORS_ENABLE_ALL_SOLID_BUTTON": "Enable All Chargers",
  "CONNECTORS_ENABLE_ALL_OUTLINE_BUTTON": "Disable All Chargers",


  "_energy_group_schedule_section": "------------------------------------------",
  "ENABLE_ENERGY_GROUP_SCHEDULE": {
    "header": "Enable $1 Schedule?",
    "data": {
      "dialogContent": [
        {
          "bold": false,
          "contentMsg": "Are you sure you want to enable $1 Schedule?"
        },
        {
          "bold": true,
          "contentMsg": "If enabled this Schedule will go into effect on its Start Date and Time."
        }
      ],
      "solidText": "Enable",
      "outlineText": "Keep Disabled"
    }
  },
  "DISABLE_ENERGY_GROUP_SCHEDULE": {
    "header": "Disable $1 Schedule?",
    "data": {
      "dialogContent": [
        {
          "bold": false,
          "contentMsg": "Are you sure you want to disable $1 Schedule?"
        },
        {
          "bold": true,
          "contentMsg": "If disabled this Schedule will be immediately unavailable for use."
        }
      ],
      "solidText": "Keep Enabled",
      "outlineText": "Disable"
    }
  },
  "DELETE_ENERGY_GROUP_SCHEDULE": {
    "header": "Delete $1 Schedule?",
    "data": {
      "dialogContent": [
        {
          "bold": false,
          "contentMsg": "Are you sure you want to delete $1 Schedule?"
        },
        {
          "bold": true,
          "contentMsg": "This will be permanently delete this Schedule. This Schedule will no longer be available for use."
        }
      ],
      "solidText": "Keep Schedule",
      "outlineText": "Delete Schedule"
    }
  }
}
